import React from 'react';

import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  RadioGroup as MuiRadioGroup,
  Radio,
  Theme,
  Typography,
  TypographyTypeMap,
} from '@mui/material';

type RadioGroupProps = {
  label?: string;
  defaultValue?: string;
  values: any[];
  value?: string;
  onChange: (value: string | number) => void;
  ['data-testid']?: string;
  error?: boolean;
  helperText?: string;
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  labelVariant?: TypographyTypeMap['props']['variant'];
  control?: React.ElementType;
  controlVariant?: 'primary' | 'outlined';
  showLabel?: boolean;
  disabled?: boolean;
  selectedKey: string;
  handleAction?: (event: any, id: number) => void;
};

export const RadioGroup: React.FC<RadioGroupProps> = ({
  label,
  values,
  defaultValue,
  error,
  helperText,
  color = 'primary',
  labelVariant = 'body1',
  value,
  onChange,
  control,
  controlVariant = 'primary',
  showLabel = true,
  disabled = false,
  selectedKey,
  handleAction,
  ...props
}) => {
  return (
    <>
      <FormControl>
        <FormLabel id={`${props['data-testid']}-label`}>{label}</FormLabel>
        <MuiRadioGroup
          {...props}
          value={value}
          onChange={(event, value) => {
            onChange(JSON.parse(value).id);
          }}
          aria-labelledby={`${props['data-testid']}-label`}
          defaultValue={''}
          data-testid={props['data-testid']}>
          {values.map((value1) => (
            <FormControlLabel
              color={error ? 'error' : color}
              key={value1.id}
              value={value1[selectedKey]}
              disabled={disabled}
              control={
                control ? (
                  React.createElement(control, {
                    isSelected: value1[selectedKey] === value,
                    label: value1.label || value1.name,
                    onChange: () => onChange(value1[selectedKey]),
                    disabled,
                    variant: controlVariant,
                    image: value1.image,
                    id: value1.id,
                    handleAction,
                  })
                ) : (
                  <Radio
                    sx={{
                      svg: {
                        '& path': {
                          fill: ({ palette }: Theme) =>
                            error ? palette.error.main : palette[color].main,
                        },
                      },
                    }}
                  />
                )
              }
              label={
                <Typography
                  variant={labelVariant}
                  color={error ? 'error' : color}>
                  {showLabel && value1.label}
                </Typography>
              }
            />
          ))}
        </MuiRadioGroup>
      </FormControl>
      {error && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </>
  );
};
